import React from "react";
import { ElfsightWidget } from 'react-elfsight-widget';

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";


const InstagramFeed = () => {
    return (
        <Container fluid tag="section" className="instagram-feed py-5">
            <Container>
                <Row tag="article" className="align-items-center">
                    <Col md="4" className="text-center text-md-left">
                        <h3>Síguenos<br/> en Instagram</h3>
                    </Col>
                    <Col md="8">
                        <ElfsightWidget widgetId="d013319d-67b9-4a03-9ca4-39858df87e7b" lazy modern />
                    </Col>
                </Row>
            </Container>
        </Container>
    )
};

export default InstagramFeed;